import { useState } from "react";

import { Icon } from "src/app/components/icon/Icon";
import { Column } from "src/core/models/global";
import { TableHead } from "src/types/global";

const TableHeader = (props: { defaultSort: Column; headers: Array<TableHead>; onSorting: (column: Column) => void }) => {
  const [sortColumn, setSortColumn] = useState(props.defaultSort.name);
  const [sortDescending, setSortDescending] = useState(props.defaultSort.sortDescending);

  const onSortChange = (field: string) => {
    const order = field === sortColumn && sortDescending ? false : true;
    setSortColumn(field);
    setSortDescending(order);
    props.onSorting({ name: field, sortDescending: order });
  };

  return (
    <thead>
      <tr className="u-col-12">
        {props.headers.map((head: TableHead) => {
          return (
            <th key={head.field} className={head.class} onClick={() => (head.sortable ? onSortChange(head.field) : null)}>
              <span>{head.name}</span>
              {sortColumn &&
                sortColumn === head.field &&
                (sortDescending ? (
                  <Icon name="arrow-down" className="u-t-valign-bottom u-t-f20p u-ml15px" />
                ) : (
                  <Icon name="arrow-up" className="u-t-valign-bottom u-t-f20p u-ml15px" />
                ))}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
